import { Flex } from "@chakra-ui/layout";
import { useState } from "react";
import colors from "theme/colors";
import OutlineButton from "components/Button/OutlineButton";
import { Popover } from "antd";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Box, Text } from "@chakra-ui/react";
import ButtonExportarExcel from "ui/components/Button/ButtonExportarExcel";
import ButtonExportarPDF from "ui/components/Button/ButtonExportarPDF";
import ButtonImprimir from "ui/components/Button/ButtonImprimir";

function ExportMenu({
  onExportPdf,
  onExportarXlsx,
  onImprimir,
  variant = "primary",
  text = "Mais opcões",
  childrenComponent,
}: {
  onExportPdf?: () => any;
  onExportarXlsx?: () => any;
  onImprimir?: () => any;
  variant?: "primary" | "transparent";
  text?: string;
  childrenComponent?: React.ReactNode;
}) {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const onClose = () => setPopoverVisible(false);

  if (!onExportPdf && !onExportarXlsx && !onImprimir) {
    return null;
  }

  return (
    <Flex>
      <Popover
        placement="bottomRight"
        arrowContent={<></>}
        arrowPointAtCenter={false}
        overlayClassName="antd-popover-hide-arrow"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={setPopoverVisible}
        overlayStyle={{
          borderRadius: 12,
          zIndex: 3,
          marginLeft: 10,
        }}
        overlayInnerStyle={{
          borderRadius: 12,
          boxShadow: "0 0 6px 2px #87878725",
          border: `solid 1px ${colors.blue}`,
          marginTop: -10,
          marginRight: -2,
          padding: 0,
        }}
        content={() => (
          <PopoverContent
            onExportPdf={onExportPdf}
            onExportarXlsx={onExportarXlsx}
            onImprimir={onImprimir}
            onClose={onClose}
            childrenComponent={childrenComponent}
          />
        )}
      >
        <OutlineButton
          lineColor={colors.blue}
          p={3}
          minW="142px"
          bgColor={variant === "primary" ? "white" : "transparent"}
        >
          <Text>{text}</Text>

          <Box w="20px" ml={-2}>
            <MdKeyboardArrowDown size={25} />
          </Box>
        </OutlineButton>
      </Popover>
    </Flex>
  );
}

const PopoverContent = ({
  onExportPdf,
  onExportarXlsx,
  onImprimir,
  onClose,
  childrenComponent = null,
}: {
  onExportPdf?: () => any;
  onExportarXlsx?: () => any;
  onImprimir?: () => any;
  onClose: () => any;
  childrenComponent?: React.ReactNode;
}) => (
  <Flex
    flexDir="column"
    alignItems="start"
    w={childrenComponent ? "fit-content" : "110px"}
  >
    {onExportPdf ? (
      <ButtonExportarPDF
        onClick={() => {
          onExportPdf?.();
          onClose();
        }}
      />
    ) : null}
    {onExportarXlsx ? (
      <ButtonExportarExcel
        onClick={() => {
          onExportarXlsx?.();
          onClose();
        }}
      />
    ) : null}
    {onImprimir ? (
      <ButtonImprimir
        onClick={() => {
          onImprimir();
          onClose();
        }}
      />
    ) : null}
    {childrenComponent}
  </Flex>
);

export default ExportMenu;
